import SignupClarityDemoPage from "@faire/prototype-playground/workspace/eg/signup-clarity-demo";
import { Route, Switch } from "react-router-dom";

export function ErelGililovRoutes() {
  return (
    <Switch>
      <Route path="/eg/signup-clarity-demo" component={SignupClarityDemoPage} />
    </Switch>
  );
}

export const slug = "eg";
